import { Component, Input, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Router } from '@angular/router';
import { TestimonialsService } from './testimonials.service';

@Component({
    selector: 'app-testimonials',
    templateUrl: './testimonials.component.html',
    styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {

	@Input() data: any[] | null = null;
  @Input() bgImage?: string;

    constructor(
		private content: TestimonialsService,
		public router: Router
    ) {}

    ngOnInit(): void {
        if(!this.data) {
          this.content.getData().subscribe((data: any) => {
            this.data = data.data.attributes.testimonialLists;
        });
      }
    }

    testimonialsSlides: OwlOptions = {
		items: 1,
		loop: true,
		nav: false,
		dots: true,
		margin: 25,
		autoplay: true,
		smartSpeed: 500,
		autoplayHoverPause: true
    }

}